import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import { fetchAllies } from '../services/alliesService';
import loadingAnimation from '../assets/loading.json';
import usePageMeta from '../hooks/usePageMeta';
import { artistAvatar } from '../lib/imageProxy';
import BlurImage from '../components/BlurImage';
import './AlliesPage.css';

const AlliesPage = () => {
  const [allies, setAllies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePageMeta({
    title: 'Aliados — Bluppimart',
    description: 'Tiendas y marcas aliadas de Bluppimart.',
  });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchAllies();
        if (!cancelled) setAllies(data);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Error al cargar los aliados.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>
        <Lottie
          animationData={loadingAnimation}
          loop
          style={{ width: 200, height: 200, margin: '0 auto' }}
        />
      </div>
    );
  }

  return (
    <article className="allies-page">
      <header className="allies-page-header">
        <h1 className="allies-page-title">Aliados</h1>
      </header>

      {error ? (
        <div className="allies-page-empty"><p>{error}</p></div>
      ) : allies.length === 0 ? (
        <div className="allies-page-empty"><p>Aún no hay aliados registrados.</p></div>
      ) : (
        <div className="allies-page-grid">
          {allies.map((ally) => (
            <Link
              key={ally.id}
              to={`/ally/${ally.slug || ally.id}`}
              className="ally-card"
            >
              <figure className="ally-card-figure">
                {ally.profile_image_url ? (
                  <BlurImage
                    src={artistAvatar(ally.profile_image_url)}
                    alt={ally.name}
                    loading="lazy"
                    objectFit="cover"
                    onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
                  />
                ) : (
                  <div className="ally-card-placeholder" aria-hidden="true">
                    {(ally.name || '?').charAt(0)}
                  </div>
                )}
              </figure>
              <figcaption className="ally-card-caption">
                <span className="ally-card-name">{ally.name}</span>
                {ally.description && (
                  <span className="ally-card-desc">{ally.description}</span>
                )}
              </figcaption>
            </Link>
          ))}
        </div>
      )}
    </article>
  );
};

export default AlliesPage;
